import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromRoot from '../../../../state/app.state';
import {ContractsService} from "./contracts.service";
import {Observable, of} from "rxjs";
import {catchError, map, mergeMap, tap} from "rxjs/operators";
import {CommonService} from "../../../shared/services/common.service";
import {
  FetchContractDetailsFailure,
  FetchContractDetailsRequest,
  FetchContractDetailsSuccess,
  UpdateContractDetailsFailure,
  UpdateContractDetailsRequest,
  UpdateContractDetailsSuccess
} from "./contracts.actions";
import {
  FetchContractDetailsModel
} from "../models/fetch-contract-details.model";
import {
  UpdateContractDetailsModel
} from "../models/update-contract-details.model";
import {Router} from "@angular/router";


@Injectable()
export class ContractsEffects {

  fetchContractDetails$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchContractDetailsRequest),
      map((action: any) => {
        this.commonService.startLoading();
        return action.payload;
      }),
      mergeMap((payload) =>
        this.contractsService.fetchContractDetails(payload).pipe(
          map((response: FetchContractDetailsModel['response']) => {
            const {data, message} = response;
            return FetchContractDetailsSuccess({contractDetails: data, message});
          }),
          catchError(() => {
            return of(FetchContractDetailsFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchContractDetailsSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchContractDetailsFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
            this.commonService.stopLoading();
          })
        )
      )
    )
  );

  previousUrl: string = '';
  updateContractDetails$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(UpdateContractDetailsRequest),
      map((action: any) => {
        this.commonService.startLoading();
        this.previousUrl = action?.previousUrl
        return action.payload;
      }),
      mergeMap((payload) =>
        this.contractsService.updateContractDetails(payload).pipe(
          map((response: UpdateContractDetailsModel['response']) => {
            const {data, message} = response;
            return UpdateContractDetailsSuccess({contractDetails: data, message});
          }),
          catchError(() => {
            return of(UpdateContractDetailsFailure());
          }),
          tap((action: any) => {
            if (action.type === UpdateContractDetailsSuccess.type) {
              // Code to execute on API Success Action dispatch
              const url = this.previousUrl?.split('?')[0]
              const queryParams = this.previousUrl?.split('?')[1].split('=')[1]
              this.router.navigate([url], {queryParams: {weekNumber: queryParams}});
              this.commonService.notification(action.message, 'success');
            } else if (action.type === UpdateContractDetailsFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
            this.commonService.stopLoading();
          })
        )
      )
    )
  );

  constructor(
    private store: Store<fromRoot.State>,
    private contractsService: ContractsService,
    private commonService: CommonService,
    private actions: Actions,
    private router: Router,
  ) {
  }
}
